import { lazy } from "react";

export const NewRewardPage = lazy(() => import("./newRewardPage"));
